import React from "react";
import ThemeSwitcher from "../ThemeSwitcher";
import LocalStorageHandler from "../LocalStorage/LocalStorageHandler";

function Navbar(props) {

    const navbarClassName = `navbar navbar-expand-sm navbar-${props.theme} bg-${props.theme}`;
    const storage = new LocalStorageHandler({ setStateCallback: props.updateLoginCallback });

    const navbarBrand = () => {
        if (!props.Brand) {
            return null;
        }
        return (
            <>
                <a className="navbar-brand" href="/">{props.Brand}</a>
            </>
        );
    }

    const toggler = () => {
        return (
            <>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
            </>
        );
    }

    const navbarElement = (element) => {
        const active = element.active ? 'active' : '';
        const nabvarElementClassName = `nav-item ${active}`;
        return (
            <>
                <li className={nabvarElementClassName}>
                    <button
                        id={element.name}
                        key={element.id}
                        // className="btn btn-primary"
                        className="nav-link"
                        onClick={element?.onClickCallback}
                    >
                        {element.name}
                    </button>
                </li>
            </>
        );
    }

    return (
        <>
            <nav className={navbarClassName}>
                <div className="container-fluid">
                    {navbarBrand()}
                    {toggler()}
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <ThemeSwitcher
                                updateThemeCallback={props.updateThemeCallback}
                                theme={props.theme}
                            />
                            {navbarElement({
                                name: 'logout',
                                active: false,
                                onClickCallback: () => {
                                    if (props?.updateLoginCallback) {
                                        storage.setItem('token', '');
                                        props.updateLoginCallback(false);
                                    }
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default Navbar;